import script from './component-lib.esm2.js';
import normalizeComponent from '../../external/vue-runtime-helpers/dist/component-lib.esm.js';
import createInjector from '../../external/vue-runtime-helpers/dist/inject-style/component-lib.esm.js';

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    staticClass: "v-simple-table",
    class: _vm.classes
  }, [_c('div', {
    staticClass: "v-simple-table__wrapper",
    style: _vm.wrapperStyles
  }, [_c('table', [_vm._t("default")], 2)])]);
};
var __vue_staticRenderFns__ = [];

/* style */
const __vue_inject_styles__ = function (inject) {
  if (!inject) return;
  inject("data-v-f5b0a050_0", {
    source: ".v-simple-table{background:#fff;border-radius:var(--g-border-radius-standard);border-radius:min(var(--g-border-radius-standard),var(--g-border-radius-min));color:var(--g-color-on-bg);line-height:1.5}.v-simple-table--gutter-top{margin-top:1rem}.v-simple-table--gutter-btm{margin-bottom:1rem}.v-simple-table--fixed-header .v-simple-table__wrapper{overflow-y:auto}.v-simple-table--fixed-header thead th{background:#fff;box-shadow:inset 0 -1px 0 rgba(0,0,0,.12)}.v-simple-table--fixed-header thead tr th{border-bottom:0!important;position:sticky;top:0;z-index:2}.v-simple-table.v-simple-table--dense tbody tr td,.v-simple-table.v-simple-table--dense tbody tr th,.v-simple-table.v-simple-table--dense tfoot tr td,.v-simple-table.v-simple-table--dense tfoot tr th,.v-simple-table.v-simple-table--dense thead tr td,.v-simple-table.v-simple-table--dense thead tr th{height:2rem}.v-simple-table__wrapper{overflow-x:auto;overflow-y:hidden}.v-simple-table table{font-family:var(--g-font-body-family);width:100%;border-spacing:0}.v-simple-table tbody tr td,.v-simple-table tbody tr th,.v-simple-table tfoot tr td,.v-simple-table tfoot tr th,.v-simple-table thead tr td,.v-simple-table thead tr th{height:3rem;padding:.25rem 1rem}.v-simple-table tbody tr th,.v-simple-table tfoot tr th,.v-simple-table thead tr th{user-select:none;font-size:.75rem}.v-simple-table tbody tr td,.v-simple-table tfoot tr td,.v-simple-table thead tr td{font-size:.875rem}.v-simple-table thead tr td,.v-simple-table thead tr th{height:2rem}.v-simple-table thead tr:last-child th{border-bottom:thin solid rgba(0,0,0,.12)}.v-simple-table tbody tr:hover{background:var(--g-color-gray-100)}.v-simple-table tbody tr:not(:last-child) td,.v-simple-table tbody tr:not(:last-child) th{border-bottom:thin solid rgba(0,0,0,.12)}",
    map: undefined,
    media: undefined
  });
};
/* scoped */
const __vue_scope_id__ = undefined;
/* module identifier */
const __vue_module_identifier__ = undefined;
/* functional template */
const __vue_is_functional_template__ = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, false, createInjector, undefined, undefined);
var __vue_component__$1 = __vue_component__;
export { __vue_component__$1 as default };